import React, { useState } from 'react';
import {
  IconButton,
  TableCell,
  TableRow,
  Tooltip,
  useTheme,
} from '@mui/material';
import { Link } from 'react-router-dom';
import { Edit, Visibility } from '@mui/icons-material';

import DeleteConfirmation from 'src/Utils/DeleteConfirmation';
import Toaster from 'src/Toaster/Toaster';
import { url } from 'src/Helpers/utils/Constant';
import axios from 'axios';
import DeleteTwoToneIcon from '@mui/icons-material/DeleteTwoTone';
import { HttpClient } from 'src/Helpers/http/http';
import ModalsWrapper from 'src/components/Modals/ModalsWrapper';
import { TOtherIncomeHeadList } from './type/otherIncomeType';
type IProps = {
  incomeHeadData: TOtherIncomeHeadList;

  index: number;
};
const OtherIncomeHeadTableRow = ({ incomeHeadData, index }: IProps) => {
  const { name } = incomeHeadData || {};
  return (
    <TableRow hover>
      <TableCell>{index + 1}</TableCell>
      <TableCell>{name}</TableCell>
    </TableRow>
  );
};

export default OtherIncomeHeadTableRow;
